module.exports = __webpack_public_path__ + "static/media/gino.30ade57e.jpg";